// AIVIQ — Proper Smooth Scroll (Lenis) for Expanse Theme
(function () {
  if (window.__aiviqLenisInit) return;
  window.__aiviqLenisInit = true;

  function init() {
    // Respect reduced motion
    const prefersReduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    if (typeof Lenis === "undefined") {
      console.warn("Lenis not loaded");
      return;
    }

    // Create Lenis
    const lenis = new Lenis({
      duration: 1.3,                 // increase = more floaty
      easing: (t) => 1 - Math.pow(1 - t, 4),
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 0.9,          // lower = heavier / smoother
      touchMultiplier: 1.2,
      normalizeWheel: true,
    });

    window.lenis = lenis;

    // RAF loop
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // ✅ Intercept anchor links (#section and /#section)
    document.addEventListener("click", function (e) {
      const a = e.target.closest("a");
      if (!a) return;

      let href = a.getAttribute("href");
      if (!href || !href.includes("#")) return;

      const hash = "#" + href.split("#").pop();
      if (hash === "#") return;

      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();

      try {
        history.pushState(null, "", hash);
      } catch (e) {}

      lenis.scrollTo(target, {
        offset: -100,   // adjust if header height changes
        duration: 1.3,
        immediate: false,
      });
    });

    // ✅ Patch native scrollTo (theme uses this internally)
    const originalScrollTo = window.scrollTo.bind(window);
    window.scrollTo = function () {
      try {
        if (arguments.length === 1 && typeof arguments[0] === "number") {
          return lenis.scrollTo(arguments[0]);
        }
        if (arguments.length === 1 && typeof arguments[0] === "object") {
          const o = arguments[0];
          if (o && typeof o.top === "number") {
            return lenis.scrollTo(o.top);
          }
        }
      } catch (e) {}
      return originalScrollTo.apply(null, arguments);
    };

    // ✅ Keep Lenis in sync with Shopify + resize
    function refresh() {
      try {
        lenis.resize();
      } catch (e) {}
    }

    window.addEventListener("resize", refresh);
    document.addEventListener("shopify:section:load", refresh);
    document.addEventListener("shopify:section:unload", refresh);

    console.log("✅ Aiviq Lenis smooth scroll active");
  }

  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(init, 0);
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();
